import React, { useMemo, useState } from 'react';
import Icon from '../../../Icon2/Icon';
import Tooltip from '../../../Tooltip/Tooltip';
import { Truncate } from '../../../Truncate/Truncate';
import Button from '../../../Button/Button';
import './ModuleCell.css'
import moment from 'moment';

export const KEYS = {
  ENTER: 'Enter',
  SPACE: ' ',
  TAB: 'Tab',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ESCAPE: 'Escape',
  c: 'c'
} as const

export const isEnterPressed = (key: string): boolean => (key === KEYS.ENTER)

export const TextClipBoard = ({ text, copyLabel, testId = "cs-asset-text-clipboard" }) => {
  const [isCopied, setCopied] = useState(false);
  const handleCopy = (e) => {
    e.stopPropagation()
    e.preventDefault()
    const copyText = text
    navigator.clipboard.writeText(copyText).then(() => {
      console.log('Async: Copying to clipboard was successful!')
      setCopied(true)
    }).catch((err) => {
      console.error('Async: Could not copy text: ', err);
    });
  }

  const handleReset = () => {
    setCopied(false);
  };
  return (
    <div className='TextClipBoard' data-test-id="cs-text-clip-board" >
      <Truncate isResponsive truncateFrom='end' endCharCount={10}>{text}</Truncate>
      <Tooltip content={!isCopied ? `Copy ${copyLabel}` : 'Copied'}
        position="left"
        trigger={isCopied ? 'mouseenter focusin' : 'mouseenter click focusin'}
        onHidden={handleReset} >
        <span aria-label={!isCopied ? `Copy ${copyLabel}` : 'Copied'} className='clipboard-copy' onClick={handleCopy} onKeyDown={(e: any) => {
          if (isEnterPressed(e.key)) {
            e.preventDefault();
            e.stopPropagation();
            e.target.click();
          }

        }}>

          <Button version="v2" buttonType="tertiary" className='TextClipBoard__icon' testId={`${testId}-copy-icon`} icon="v2-Copy" onlyIcon={true} onlyIconHoverColor="secondary" />

        </span>
      </Tooltip>
    </div>
  )
}

interface PropsTwoLayerTextDisplay {
  primaryText: string;
  secondaryText?: string;
  isPrimaryTextWithDate?: boolean;
  testId?: string;
  hasVariantPlanEnabled?: boolean;
  data?: any;
  isVariantForTask?: boolean
}

export const TwoLayerTextDisplay = (props: PropsTwoLayerTextDisplay) => {
  const { primaryText, secondaryText, isPrimaryTextWithDate, testId = 'cs-two-layer', hasVariantPlanEnabled, data, isVariantForTask } = props;

  let date = primaryText;
  if (isPrimaryTextWithDate) {
    if (typeof date === 'number')
      date = (date as number).toString();
    date = moment(date).format('MMM DD, YYYY [ ]hh:mm A')
  }

  const UI = useMemo(() => {
    return (
      <div className='flex-justify'>
        <div className={`TwoLayerTextDisplay__container ${hasVariantPlanEnabled && !data?.hasOwnProperty('title') ? 'variantWithoutTitle' : ''}`} >
          <Truncate
            isResponsive
            truncateFrom='end'
            testId={`${testId}-primaryText`} >
            {isPrimaryTextWithDate ? date : primaryText}
          </Truncate>
          {secondaryText ?
            <Truncate
              testId={`${testId}-secondaryText`}
              truncateFrom='end'
              isResponsive >
              {secondaryText}
            </Truncate>
            : null}
        </div>
        {
          (((hasVariantPlanEnabled && data.hasOwnProperty('_base_entry_version') && data.hasOwnProperty('_variants_info'))) || isVariantForTask) && (
            <Icon icon='Variant' version='v2' size='medium' />
          )
        }
      </div>
    )
  }, [primaryText, secondaryText, isPrimaryTextWithDate])

  return (
    <div className='TwoLayerTextDisplay' data-test-id={`${testId}-wrapper`} >
      {UI}
    </div>

  )
}